import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BookingCard.css';
import PayButton from '../../../components/shared/payButton/PayButton';
import { useAuth } from '../../../context/AuthContext';
import { TicketModal } from '../../../components/shared/TicketModal/TicketModal';

export const BookingCard = ({ booking }) => {
  const { user } = useAuth();
  const userId = user?.result?._id ;
  const navigate = useNavigate();
  
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  
  const event = booking?.eventId;
  const paymentStatus = booking?.paymentStatus || 'Pending';
  
  // Check if pending for grayscale effect
  const isPending = paymentStatus === 'Pending';

  const isEventExpired = () => {
    const baseDate = event?.endDate || event?.startDate || booking?.subscriptionStartDate;
    if (!baseDate) return false;

    const date = new Date(baseDate);

    if (event?.startTime && !Number.isNaN(date.getTime())) {
      const timeMatch = String(event.startTime).match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
      if (timeMatch) {
        let hours = parseInt(timeMatch[1], 10);
        const minutes = parseInt(timeMatch[2], 10);
        const meridiem = timeMatch[3]?.toUpperCase();
        if (meridiem === 'PM' && hours < 12) hours += 12;
        if (meridiem === 'AM' && hours === 12) hours = 0;
        date.setHours(hours, minutes, 0, 0);
      }
    }

    return date.getTime() < Date.now();
  };

  const isExpired = isEventExpired();

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'TBD';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatMonthLabel = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  // Navigate to card details
  const handleViewDetails = () => {
    if (event?._id) {
      navigate(`/event-details/${event._id}`);
    }
  };

  // Open ticket modal
  const handleViewTicket = () => {
    setIsTicketModalOpen(true);
  };

  return (
    <>
      <div
        className={`booking-card-simple ${isExpired ? 'is-expired' : ''}`}
        onClick={isExpired ? undefined : handleViewDetails}
        role={isExpired ? 'presentation' : 'button'}
      >
        {/* Image Section */}
        <div className={`card-image-container ${(isPending || isExpired) ? 'grayscale' : ''}`}>
          <img 
            src={event?.banner_Image} 
            alt={event?.title || 'Event'} 
            className="card-image" 
          />

          {isExpired && (
            <div className="expired-overlay" onClick={(e) => e.stopPropagation()}>
              Event Expired
            </div>
          )}
          
          {/* Payment Pending Overlay */}
          {isPending && (
            <div className="pending-overlay" onClick={(e) => e.stopPropagation()}>
              {
                booking?.ticketDetails?.available >= booking?.ticketsCount?
                (
<PayButton
                userId={userId}
                eventId={event?._id}
                ticketId={booking?.ticketId}
                ticketsCount={booking?.ticketsCount}
                initialPrice={booking?.amountPaid}
                eventName={event?.title}
                onBookingSuccess={(data) => console.log('Booking success:', data)}
                onBookingFailure={(error) => console.log('Booking failure:', error)}
                disabled={false}
                isSoldOutText={false ? 'Sold Out' : null}
                bookingId={booking?._id}
                orderId={booking?.orderId}
                 platformfee={booking?.ticketDetails?.platformFee}
                 eventData={event}
              />
                )
                :
                <div className="">
                  SOLD OUT
                </div>
              }
              
            </div>
          )}
        </div>

        {/* Content Section */}
        <div className="card-content">
          <div className="card-info">
            <h3 className="card-title">{event?.title || 'Untitled Event'}</h3>
            <div className="card-meta">
              <span className="meta-item">
                <i className="far fa-calendar-alt"></i>
                {formatDate(booking?.subscriptionStartDate || event?.startDate)}
              </span>
              {booking?.subscriptionStartDate && (
                <span className="meta-item">
                  <i className="far fa-calendar"></i>
                  {formatMonthLabel(booking.subscriptionStartDate)}
                </span>
              )}
              <span className="meta-item">
                <i className="far fa-clock"></i>
                {event?.startTime || '7:00 PM'}
              </span>
            </div>
          </div>

          {/* Show View Ticket button only if payment is completed */}
          {!isPending && !isExpired && (
            <div className="card-action" onClick={(e) => e.stopPropagation()}>
              <button className="book-btn" onClick={handleViewTicket}>
                View Ticket
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Ticket Modal */}
      <TicketModal 
        isOpen={isTicketModalOpen} 
        onClose={() => setIsTicketModalOpen(false)} 
        booking={booking} 
      />
    </>
  );
};
